import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentUserOrFail } from '@/redux/slices/session'

/**
 * Only use this hook in places where you're sure that the user is authenticated
 */
export function useCurrentUserOrFail() {
  return useAppSelector(selectCurrentUserOrFail)
}
